// Maximus Bot (iGotSolutions): how a group post is shown, and the line a bot uses to ask the owner.

/** Last line of a bot message that asks the human owner for something. */
export const OWNER_REQUEST_LINE_PREFIX = "NEEDS_YOU:";

/** A group post longer than this collapses behind Show more. */
export const GROUP_POST_COLLAPSE_CHARS = 560;

/** A group post with more non-empty lines than this collapses behind Show more. */
export const GROUP_POST_COLLAPSE_LINES = 8;

const PREVIEW_LINES = 2;
const PREVIEW_CHARS = 320;

export function splitOwnerRequest(text: string): { body: string; ask?: string } {
  const lines = text.split("\n");
  let last = lines.length - 1;
  while (last >= 0 && lines[last]!.trim() === "") last -= 1;
  if (last < 0) return { body: text };
  const line = lines[last]!.trim();
  if (!line.startsWith(OWNER_REQUEST_LINE_PREFIX)) return { body: text };
  const ask = line.slice(OWNER_REQUEST_LINE_PREFIX.length).trim();
  if (!ask) return { body: text };
  return { body: lines.slice(0, last).join("\n").trimEnd(), ask };
}

export function groupPostCollapses(text: string): boolean {
  const trimmed = text.trim();
  if (!trimmed) return false;
  const lines = trimmed.split("\n").filter((line) => line.trim().length > 0);
  return trimmed.length > GROUP_POST_COLLAPSE_CHARS || lines.length > GROUP_POST_COLLAPSE_LINES;
}

/** The lead of a collapsed group post: the opening paragraph, cut on a word when it is huge. */
export function groupPostPreview(text: string): string {
  const trimmed = text.trim();
  if (!groupPostCollapses(trimmed)) return trimmed;
  const kept: string[] = [];
  let nonEmpty = 0;
  for (const line of trimmed.split("\n")) {
    if (!line.trim() && nonEmpty > 0) break;
    kept.push(line);
    if (line.trim()) nonEmpty += 1;
    if (nonEmpty >= PREVIEW_LINES) break;
  }
  let preview = kept.join("\n").trim();
  if (preview.length > PREVIEW_CHARS) {
    const cut = preview.slice(0, PREVIEW_CHARS);
    const space = cut.lastIndexOf(" ");
    preview = (space > 200 ? cut.slice(0, space) : cut).trimEnd();
  }
  return preview.length < trimmed.length ? `${preview}…` : preview;
}
